/*
 * 企業側 案件詳細
 */
import { apiUpdate } from '@/actions/ApiBaseActions';
export const API_UPDATE_CLIENT_RFP_VIEW_REQUEST_DISCLOSE = 'API_UPDATE_CLIENT_RFP_VIEW_REQUEST_DISCLOSE';
export const API_UPDATE_CLIENT_RFP_VIEW_REQUEST_PROPOSAL_REQUEST_COMMENT = 'API_UPDATE_CLIENT_RFP_VIEW_REQUEST_PROPOSAL_REQUEST_COMMENT';
export const API_UPDATE_CLIENT_RFP_OFFER_PAGE_VIEW = 'API_UPDATE_CLIENT_RFP_OFFER_PAGE_VIEW';
/**
 * 閲覧申請の会社名開示の更新
 * TODO: - viewRequestIdが配列なので、viewRequestIdsにリネームしたい
 */
export const apiUpdateClientRfpViewRequestDisclose = ({ json, path: { id } }, meta) => apiUpdate(API_UPDATE_CLIENT_RFP_VIEW_REQUEST_DISCLOSE, `/client/rfp/${id}/disclose`, json, Object.assign(Object.assign({}, meta), { id }));
/**
 * 閲覧申請の提案希望コメントを更新
 * TODO: - viewRequestIdが配列なので、viewRequestIdsにリネームしたい
 */
export const apiUpdateClientRfpViewRequestProposalRequestComment = ({ json, path: { id } }, meta) => apiUpdate(API_UPDATE_CLIENT_RFP_VIEW_REQUEST_PROPOSAL_REQUEST_COMMENT, `/client/rfp/${id}/proposal_request_comment`, json, Object.assign(Object.assign({}, meta), { id }));
/**
 * 提案PDF資料の閲覧の更新
 */
export const apiUpdateClientRfpOfferPageView = ({ path: { id, page, page_view_id: pageViewId, view_request_id: viewRequestId, }, }, meta) => apiUpdate(API_UPDATE_CLIENT_RFP_OFFER_PAGE_VIEW, `client/rfp/${id}/offer/${viewRequestId}/page/${page}/view/${pageViewId}`, {}, meta);
